import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-18fed4ed"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sidebar-comp"
};
const __default__ = {
  name: 'sidebar-comp',
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
import { ref, watch, onBeforeMount, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import RoutesMenu from './routesMenu.vue';
// ********************(基本参数)********************

export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    opened: {
      type: Boolean,
      default: true
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const $store = useStore();
    const router = useRouter();
    const routes = router.getRoutes();
    const route = useRoute();

    // 菜单组件实例
    const menuRef = ref(null);

    // 接收父组件传递的数据

    // 路由菜单
    // const routesMenu = ref([])
    const routesMenu = computed(() => $store.state.fpRoutes);
    // 默认展开
    const defaultOpeneds = ref([]);
    // 默认选中的路由
    const defaultActive = ref('');
    // 找到路由根元素
    // const root = routes.find((item) => item.path === '/')
    // 递归
    // const routesRecursion = (routesList, superiorRoute) => {
    //   // console.log('routesRecursion', routesList);
    //   routesList.forEach((item) => {
    //     // 如果没有企业白名单权限则隐藏企业尽调菜单
    //     if (!$store.getters.jcaReportWhiteListPermission && item.path === '/enterpriseDueDiligence') {
    //       item.meta.hidden = true
    //     }
    //     const meta = item.meta
    //     // 功能权限相关的code
    //     const code = meta.code
    //     // 是否允许进入此路由
    //     let allow = true
    //     // 存在code的路由才需要此判断，其他路由默认允许
    //     if (code) {
    //       // 判断是否存在权限
    //       const exist = functionalPermissions.value.find(fpItem => fpItem.code === code)
    //       allow = exist ? true : false
    //     }
    //     // 取出需要在路由菜单中展示的项
    //     if (!meta.hidden && allow) {
    //       let menuItem = {}
    //       menuItem.icon = meta.icon
    //       menuItem.title = meta.title
    //       menuItem.path = item.path
    //       menuItem.name = item.name
    //       if (meta.isParent) {
    //         menuItem.children = []
    //         routesRecursion(item.children, menuItem.children)
    //         defaultOpeneds.value.push(menuItem.path)
    //       }
    //       menuItem.isParent = meta.isParent ? true : false
    //       superiorRoute.push(menuItem)
    //     }
    //   })
    // }

    // ********************(根据功能权限配置侧边导航栏)********************
    // 功能权限
    // const functionalPermissions = computed(() => $store.getters.functionalPermissions)
    // 监听功能权限变更
    // watch(() => functionalPermissions.value, (newValue) => {
    //   if (newValue && Array.isArray(newValue) && newValue.length > 0) {
    //     // console.log('root.children', root.children, newValue, newValue.length);
    //     // 清空信息
    //     routesMenu.value = []
    //     defaultOpeneds.value = []
    //     // 处理路由信息
    //     routesRecursion(root.children, routesMenu.value)
    //     // 设置默认页面
    //     setDefaultPath()
    //   }
    // }, { immediate: true, deep: true })

    // ********************(默认路由)********************
    // 监听路由
    watch(() => route.path, (newValue, _) => {
      // console.log('watch', newValue, _)
      // parentPath 记录当前激活菜单
      defaultActive.value = route.meta.parentPath || newValue;
    });
    // 在挂载之前设置默认选中的路由
    onBeforeMount(() => {
      defaultActive.value = route.path;
    });
    // 设置默认的页面
    // function setDefaultPath() {
    //   console.log('routesMenu', routesMenu.value)
    //   // 设置默认选中的路由
    //   const defaultPath = routesMenu.value[0].isParent
    //     ? routesMenu.value[0].children[0].path
    //     : routesMenu.value[0].path
    //   $store.commit('setFpDefaultPath', defaultPath)
    // }

    // ********************(跳转页面)********************
    // 跳转页面
    const jumpPage = function (...rest) {
      // if (rest[0] == '/customReport') {
      //   const params = {
      //     id: 'cmh',
      //     // template_type: item.template_type,
      //     // report_type: item.report_type,
      //     // report_name: report_name.value,
      //     // hasUsedTemplate: usedTemplate.value.length > 0,
      //   }
      //   Object.assign(params, { partner_code: router.currentRoute.value.query.partner_code })
      //   const routerUrl = router.resolve({
      //     path: '/customReportBlank',
      //     query: params,
      //   })
      //   return window.open(routerUrl.href, '_blank')
      // }
      router.push(rest[0]);
    };

    // ********************(暴露方法)********************
    expose({
      open: computed(() => {
        var _menuRef$value;
        return (_menuRef$value = menuRef.value) === null || _menuRef$value === void 0 ? void 0 : _menuRef$value.open;
      }),
      close: computed(() => {
        var _menuRef$value2;
        return (_menuRef$value2 = menuRef.value) === null || _menuRef$value2 === void 0 ? void 0 : _menuRef$value2.close;
      })
    });
    return (_ctx, _cache) => {
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          ref_key: "menuRef",
          ref: menuRef,
          collapse: !__props.opened,
          "unique-opened": false,
          "default-active": defaultActive.value,
          "default-openeds": defaultOpeneds.value,
          "background-color": "#081829",
          "text-color": "#ffffffbd",
          "active-text-color": "#fff",
          onSelect: jumpPage
        }, {
          default: _withCtx(() => [_createVNode(RoutesMenu, {
            level: 0,
            menu: _unref(routesMenu)
          }, null, 8, ["menu"])]),
          _: 1
        }, 8, ["collapse", "default-active", "default-openeds"])]),
        _: 1
      })]);
    };
  }
});